import {Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {MatDialog} from "@angular/material/dialog";
import {AddSamplesDialogComponent} from "../../dialogs/lab-manager/add-samples-dialog/add-samples-dialog.component";
import {data} from "autoprefixer";
import {
  DraftConfirmationDialogComponent
} from "../../dialogs/draft-confirmation-dialog/draft-confirmation-dialog.component";
import {LabManagerService} from "../lab-manager.service";
import {LabSampleModel} from "../../models/lab-manager/lab-sample";
import {NavBarComponent} from "../../nav-bar/nav-bar.component";
import dayjs from "dayjs";
import {PageEvent} from "@angular/material/paginator";
import {
  AnalysisRequiredDialogComponent
} from "../../dialogs/lab-manager/analysis-required-dialog/analysis-required-dialog.component";
import {LabSubmissionDetailsModel} from "../../models/lab-manager/lab-submission-details";
import {CustomerModel} from "../../order-to-cash/models-otc/customer-model";
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from "@angular/material/core";
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter} from "@angular/material-moment-adapter";

export const LAB_MANAGER_DATE_FORMAT = {
  parse: {
    dateInput: "YYYY-MM-DD"
  },
  display: {
    dateInput: "YYYY-MM-DD",
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
    selector: 'app-lab-samples',
    templateUrl: './lab-samples.component.html',
    styleUrls: ['./lab-samples.component.css'],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useValue: LAB_MANAGER_DATE_FORMAT }
    ],
    standalone: false
})
export class LabSamplesComponent implements OnInit, OnChanges {

  @Input() selectedCustomer: CustomerModel;
  @Input() submissionId: number = 0;
  @Input() pinTypeId: number = 0;
  @Input() submissionStatus: number = null;
  currentPage: number = 0;
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  displayedColumns: string[] = [
    'checkbox',
    'sample',
    'sampleType',
    'dateCreated',
    'farm',
    'field',
    'hectare',
    'createdBy',
    'linkedGroup',
    'action'
  ];
  filterStartDate: string = '';
  filterEndDate: string = '';
  pageSize: number = 9999;
  searchText: string = '';
  startDate: string = '';
  endDate: string = '';
  tableHeight: string = (window.innerHeight - 500) + 'px';
  totalElements: number = 0;
  timerInterval: any = null;
  selectedSamples: number[] = [];
  isFilterBtnVisible: boolean = false;
  mergeGroups: any[] = [];
  @Output() sampleChange: EventEmitter<any> = new EventEmitter<any>();

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.tableHeight = (window.innerHeight - 500) + 'px';
  }

  constructor(
      private dialog: MatDialog,
      private labManagerService: LabManagerService,
      private nav: NavBarComponent
  ) {
  }

  ngOnInit(): void {
  }

  resetFilter(){
    this.searchText = '';
    this.startDate = '';
    this.endDate = '';
    this.filterStartDate = '';
    this.filterEndDate = '';
    this.isFilterBtnVisible = false;
    this.getLabSampleListById();
  }

  getLabSampleListById() {
    if(this.submissionId) {
      this.nav.toggleLoading(true);
      if(this.timerInterval) {
        clearInterval(this.timerInterval);
      }
      this.sampleChange.emit();
      this.labManagerService.getLabSamplesListById(this.submissionId, this.currentPage, this.pageSize, this.startDate, this.endDate, this.searchText).subscribe({
        next: (res: any) => {
          this.totalElements = res.totalElements;
          this.dataSource = res;
          this.nav.toggleLoading(false);
        },
        error: () => {
          this.nav.toggleLoading(false);
        }
      })
    }
  }

  openAddSamplesDialog() {
    const dialogRef = this.dialog.open(AddSamplesDialogComponent, {
      data: {
        tenantId: this.selectedCustomer.tenant.id,
        pinTypeId: this.pinTypeId
      },
      width: '1590px',
      height: '825px'
    });

    dialogRef.afterClosed().subscribe((sampleList: LabSampleModel[]) => {
      if(sampleList) {
        let count = 0;
        this.nav.toggleLoading(true);
        for(let sample of sampleList) {
          this.labManagerService.addLabSample(sample.id, Number(this.submissionId), sample.pinId).subscribe({
            next: (res) => {
              count++;
              if(count === sampleList.length) {
                this.nav.toggleLoading(false);
                this.getLabSampleListById();
              }
            },
            error: () => {
              count++;
              if(count === sampleList.length) {
                this.nav.toggleLoading(false);
                this.getLabSampleListById();
              }
            }
          })
        }
      }
    })
  }

  filterDateRange() {
    if(this.filterStartDate && this.filterEndDate) {
      this.isFilterBtnVisible = true;
      this.startDate = this.filterStartDate ? dayjs(this.filterStartDate).format('YYYY-MM-DD') : '';
      this.endDate = this.filterEndDate ? dayjs(this.filterEndDate).format('YYYY-MM-DD') : '';
      this.getLabSampleListById();
    }
  }

  removeSamplesDialog(selectedSamples: any[]) {
    const dialogRef = this.dialog.open(AnalysisRequiredDialogComponent, {
      data: {
        dialogTitle: 'REMOVE SAMPLES',
        dialogType: 'remove',
        selectedLength: selectedSamples.length,
        totalSamples: this.totalElements
      },
      width: '420px'
    });

    dialogRef.afterClosed().subscribe({
      next: (res: any) => {
        if(res === 1) {
          this.removeSamples(selectedSamples);
        } else if(res === 2) {
          this.nav.toggleLoading(true);
          this.labManagerService.removeAllSamples(this.submissionId).subscribe({
            next: () => {
              this.nav.toggleLoading(false);
              this.getLabSampleListById();
            },
            error: () => {
              this.nav.toggleLoading(false);
              this.getLabSampleListById();
            }
          })
        }
      }
    })
  }

  searchLabSamples() {
    if(this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    this.timerInterval = setInterval(() => {
      this.isFilterBtnVisible = this.searchText.length > 0;
      this.getLabSampleListById();
    }, 800);
  }

  removeSamples(selectedSamples: any[]) {
    let count = 0;
    this.nav.toggleLoading(true);
    for(let sample of selectedSamples) {
      this.labManagerService.removeLabSample(sample.id).subscribe({
        next: () => {
          count++;
          if(count === selectedSamples.length) {
            this.nav.toggleLoading(false);
            this.getLabSampleListById();
          }
        },
        error: () => {
          count++;
          if(count === selectedSamples.length) {
            this.nav.toggleLoading(false);
          }
        }
      })
    }
  }

  removeSampleDialog(selectedSample: any) {
    const dialogRef = this.dialog.open(DraftConfirmationDialogComponent, {
      data: {
        dialogType: 'remove',
        dialogTitle: 'REMOVE SAMPLE',
        dialogSubTitle: 'Are you sure you want to remove the sample?'
      }
    });

    dialogRef.afterClosed().subscribe((res) => {
      if(res) {
        this.removeSamples([selectedSample]);
      }

    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes?.submissionId) {
      this.getLabSampleListById();
      this.loadMergeGroups();
    }
  }

  loadMergeGroups() {
    if (this.submissionId) {
      this.labManagerService.getMergeGroups(this.submissionId).subscribe({
        next: (groups) => this.mergeGroups = groups || [],
        error: () => this.mergeGroups = []
      });
    }
  }

  getMergeCount(sampleId: number): number {
    const group = this.mergeGroups.find(g => g.primarySampleId === sampleId);
    return group ? group.linkedCount + 1 : 0;
  }

  mergeSamples(selectedSamples: LabSampleModel[]) {
    if (selectedSamples.length < 2) return;
    const primaryId = selectedSamples[0].id;
    const linkedIds = selectedSamples.slice(1).map(s => s.id);

    this.nav.toggleLoading(true);
    this.labManagerService.mergeSamples(this.submissionId, primaryId, linkedIds).subscribe({
      next: () => {
        this.nav.toggleLoading(false);
        this.getLabSampleListById();
        this.loadMergeGroups();
      },
      error: () => {
        this.nav.toggleLoading(false);
      }
    });
  }

  unmergeSamples(primarySampleId: number) {
    this.nav.toggleLoading(true);
    this.labManagerService.unmergeSamples(primarySampleId).subscribe({
      next: () => {
        this.nav.toggleLoading(false);
        this.getLabSampleListById();
        this.loadMergeGroups();
      },
      error: () => {
        this.nav.toggleLoading(false);
      }
    });
  }
}
